<ng-container *ngIf="this.isLoading === false; else spinner" class="modal-content">
  <h4 class="title">Storage Account Information</h4>
  <mat-card class="section-card">
    <mat-card-title>Queue Storage</mat-card-title>
    <mat-card-content>
      <div class="info-pair">
        <span class="label">Queue Storage Account Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.queueStorageAccountName"
          hoverText="Click to copy Queue Storage Account Name"
          [copyText]="storageAccountInfo.queueStorageAccountName">
        </sk-click-to-copy>
      </div>
      <div class="info-pair">
        <span class="label">Queue Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.queueName"
          hoverText="Click to copy Queue Name"
          [copyText]="storageAccountInfo.queueName">
        </sk-click-to-copy>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="section-card">
    <mat-card-title>Table Storage</mat-card-title>
    <mat-card-content>
      <div class="info-pair">
        <span class="label">Table Storage Account Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.tableStorageAccountName"
          hoverText="Click to copy Table Storage Account Name"
          [copyText]="storageAccountInfo.tableStorageAccountName">
        </sk-click-to-copy>
      </div>
      <div class="info-pair">
        <span class="label">Structural Table Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.structuralTableName"
          hoverText="Click to copy Structural Table Name"
          [copyText]="storageAccountInfo.structuralTableName">
        </sk-click-to-copy>
      </div>
      <div class="info-pair">
        <span class="label">Revision Table Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.revisionTableName"
          hoverText="Click to copy Revision Table Name"
          [copyText]="storageAccountInfo.revisionTableName">
        </sk-click-to-copy>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="section-card">
    <mat-card-title>Blob Storage</mat-card-title>
    <mat-card-content>
      <div class="info-pair">
        <span class="label">Blob Storage Account Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.blobStorageAccountName"
          hoverText="Click to copy Blob Storage Account Name"
          [copyText]="storageAccountInfo.blobStorageAccountName">
        </sk-click-to-copy>
      </div>
      <div class="info-pair">
        <span class="label">Blob Container Name:</span>
        <sk-click-to-copy
          [displayText]="storageAccountInfo.blobContainerName"
          hoverText="Click to copy Blob Container Name"
          [copyText]="storageAccountInfo.blobContainerName">
        </sk-click-to-copy>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #spinner>
  <mat-spinner class="loading-spinner"></mat-spinner>
</ng-template>